import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  enh_action: 'add',
  event_name: 'add_to_bag',
  event_category: 'ecommerce',
  event_action: 'add to bag',
  event_label: null, // '<product name> - <product ID>'
  product_id: null, // '<product id>'
  product_shade: null, // '<product shade>'
  product_size: null, // '<product size>'
  product_sku: null, // '<sku id>'
};

function trackAddToCart(_: string, eventData: IDataLayer = {}) {
  if (eventData.is_pincer_cart) {
    eventData = trackAddToCartPincer(_, eventData);
  } else if (eventData.is_bf_cart) {
    eventData = trackAddToCartBF(_, eventData);
  } else {
    eventData.event_label =
      tealium.dataLayer.formatProductEventLabel(eventData);
  }

  if (eventData.event_label !== '') {
    tealium.evtLink({ ...defaultData, ...eventData });
  }
}

function trackAddToCartPincer(_: string, eventData: IDataLayer = {}) {
  // TODO: investigate why this is being pulled from the data layer before the event is fired
  // why isn't this being passed in the actual event, then added to the datalayer?
  const productCodes = eventData.product_product_code || [];
  const data = tealium.dataLayer?.data || {};
  const sku = eventData.product_sku || [];

  if (eventData.product_sku?.length) {
    let skuIndex = data.cart_product_sku?.indexOf(sku[0]) ?? -1;

    if (skuIndex === -1) {
      let skuId = productCodes[0].toString().toUpperCase();
      skuId = skuId.startsWith('SKU') ? skuId : `SKU${skuId}`;
      skuIndex = data.product_impression_sku?.indexOf(skuId) ?? -1;
    }

    if (skuIndex >= 0) {
      eventData = updateEventData(eventData, data, skuIndex, 'cart_product_');
    }
  }

  return eventData;
}

function trackAddToCartBF(_: string, eventData: IDataLayer = {}) {
  const productCodes = eventData.product_product_code || [];
  const data = tealium?.dataLayer?.data || {};
  let isRecommendProd = false;

  if (productCodes.length) {
    let skuIndex = -1;
    if (data.page_type === 'product') {
      skuIndex = data.product_product_code?.indexOf(productCodes[0]) ?? -1;
      if (skuIndex === -1) {
        skuIndex = data.product_impression_product_code?.indexOf(productCodes[0]) ?? -1;
        isRecommendProd = true;
      }
    } else {
      skuIndex =
        data.product_impression_product_code?.indexOf(productCodes[0]) ?? -1;
      if (skuIndex === -1) {
        skuIndex =
          data.product_impression_base_id?.indexOf(productCodes[0]) ?? -1;
      }
      if (skuIndex === -1) {
        let skuId = productCodes[0].toString().toUpperCase();
        skuId = skuId.startsWith('SKU') ? skuId : `SKU${skuId}`;
        skuIndex = data.product_impression_sku?.indexOf(skuId) ?? -1;
      }
    }

    if (skuIndex >= 0) {
      if (data.page_type === 'product' && !isRecommendProd) {
        eventData = updateEventData(eventData, data, skuIndex);
      } else {
        eventData = updateEventData(
          eventData,
          data,
          skuIndex,
          'product_impression_',
        );
      }
    }
  }

  return eventData;
}

function updateEventData(
  eventData: IDataLayer,
  data: IDataLayer,
  skuIndex: number,
  prefix = 'product_',
) {
  eventData.event_label = tealium.dataLayer.formatProductEventLabel({
    product_name: [data[`${prefix}name`]?.[skuIndex] || ''],
    product_id: [data[`${prefix}id`]?.[skuIndex] || ''],
  });
  eventData.product_id = [data[`${prefix}id`]?.[skuIndex] || ''];
  eventData.product_is_replenishment_item = [
    data[`${prefix}is_replenishment_item`]?.[skuIndex] || 'no',
  ];
  eventData.product_price = [
    Number.parseFloat(data[`${prefix}price`]?.[skuIndex] || 0).toFixed(2),
  ];
  eventData.product_product_code = [
    data[`${prefix}product_code`]?.[skuIndex] || '',
  ];
  eventData.product_replenishment_frequency = [
    data[`${prefix}replenishment_frequency`]?.[skuIndex] || '',
  ];
  eventData.product_shade = [data[`${prefix}shade`]?.[skuIndex] || ''];
  eventData.product_size = [data[`${prefix}size`]?.[skuIndex] || ''];
  eventData.product_sku = [data[`${prefix}sku`]?.[skuIndex] || ''];
  eventData.product_name = [data[`${prefix}name`]?.[skuIndex] || ''];
  eventData.product_base_id = [data[`${prefix}base_id`]?.[skuIndex] || ''];
  eventData.product_category = [data[`${prefix}category`]?.[skuIndex] || ''];
  eventData.product_impression_list = [
    data[`${prefix}list1`]?.[skuIndex] || location.pathname,
  ];
  eventData.product_url = [data[`${prefix}url`]?.[skuIndex] || ''];

  return eventData;
}

registerAnalyticsEventHandler('addToCart', trackAddToCart);
